/**
 * Navigation utilities for consistent routing behavior
 */

import { isDemoMode } from '../services/dataScope';

/**
 * Navigate to a project page with the project ID in the URL
 * This will scroll to and highlight the project in the projects list
 */
export const navigateToProject = (navigate: (path: string) => void, projectId: string) => {
  if (isDemoMode()) return;
  navigate(`/app/projects?project=${projectId}`);
};

/**
 * Navigate to pricing page from within the app
 */
export const navigateToPricing = (navigate: (path: string) => void) => {
  navigate('/pricing');
};



